<p>Finished export... Your exported file is ready for download.</p>

@if(data(); as data){
    @if (data.mode === 0) {
        <a [href]="data.url" target="_blank" rel="noopener" class="primary-text text-decoration-underline">View File</a>
    }@else{
        <a [href]="data.url" download rel="noopener" class="primary-text text-decoration-underline">Download File</a>
    }
}


